import { useReducer } from "react";
import { initialState } from "./Header.model";

import { HEADER_ACTIONS } from "./Header.actions";
import { HeaderReducer } from "./Header.reducer";
import { HeaderServices } from "./Header.service";

export const useHeaderComponentHooks = () => {
  const [state, dispatch] = useReducer(HeaderReducer, initialState);
  const services = HeaderServices();
  const actions = HeaderActions(dispatch, services);

  return { state, actions };
};

const HeaderActions = (dispatch, services) => {
  const actions = {
    resetPassword: async (userId) => {
      dispatch({
        type: HEADER_ACTIONS.LOADING,
        payload: true,
      });
      services
        .sendResetPasswordLink(userId)
        .then((response) => {
          if (response?.error) {
            dispatch({
              type: HEADER_ACTIONS.ERROR,
              payload:
                response?.error ??
                "We couldn't send the reset password link. Please try again.",
            });
          } else {
            dispatch({
              type: HEADER_ACTIONS.SUCCESS,
              payload: true,
            });
          }
        })
        .catch((error) => {
          dispatch({
            type: HEADER_ACTIONS.ERROR,
            payload:
              error?.message ??
              "We couldn't send the reset password link. Please try again.",
          });
        });
    },
    reset: () => {
      dispatch({
        type: HEADER_ACTIONS.RESET,
        payload: true,
      });
    },
  };
  return actions;
};
